"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import type { BaseRendererProps } from "../types/renderer-props";
import { getResolvedAnimationSrc } from "../utils/animation-source";
import { getArweaveGatewayFallbackUrls } from "../utils/gateway-fallback";
const IFRAME_FALLBACK_TIMEOUT_MS = 8000;
function getSrc(nft: BaseRendererProps["nft"]): string | undefined {
  return getResolvedAnimationSrc(nft);
}
export default function NFTHTMLRenderer(props) {
  const $ = _c(32);
  let t0;
  if ($[0] !== props.nft) {
    t0 = getSrc(props.nft);
    $[0] = props.nft;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const src = t0;
  const animationClassName = styles.nftAnimation ?? "";
  let t1;
  if ($[2] !== src) {
    t1 = src ? getArweaveGatewayFallbackUrls(src) : [];
    $[2] = src;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const urls = t1;
  const [activeIndex, setActiveIndex] = useState(0);
  const [didLoadCurrentUrl, setDidLoadCurrentUrl] = useState(false);
  const activeUrl = urls[activeIndex];
  let t2;
  if ($[4] !== urls.length) {
    t2 = () => {
      if (urls.length === 0) {
        setActiveIndex(0);
        setDidLoadCurrentUrl(false);
        return;
      }
      setActiveIndex(0);
      setDidLoadCurrentUrl(false);
    };
    $[4] = urls.length;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== urls) {
    t3 = [urls];
    $[6] = urls;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDidLoadCurrentUrl(false);
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeUrl) {
    t5 = [activeUrl];
    $[9] = activeUrl;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[11] !== activeIndex || $[12] !== activeUrl || $[13] !== didLoadCurrentUrl || $[14] !== urls.length) {
    t6 = () => {
      if (!activeUrl || didLoadCurrentUrl || activeIndex + 1 >= urls.length) {
        return;
      }
      const timeoutId = globalThis.setTimeout(() => {
        setActiveIndex(current => current === activeIndex && current + 1 < urls.length ? current + 1 : current);
      }, IFRAME_FALLBACK_TIMEOUT_MS);
      return () => {
        globalThis.clearTimeout(timeoutId);
      };
    };
    t7 = [activeIndex, activeUrl, didLoadCurrentUrl, urls.length];
    $[11] = activeIndex;
    $[12] = activeUrl;
    $[13] = didLoadCurrentUrl;
    $[14] = urls.length;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] !== urls.length) {
    t8 = () => {
      setActiveIndex(current_0 => current_0 + 1 < urls.length ? current_0 + 1 : current_0);
    };
    $[17] = urls.length;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const advanceToNextUrl = t8;
  const t9 = `${animationClassName} ${props.heightStyle} ${props.imageStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
  let t10;
  if ($[19] !== props.height || $[20] !== props.nft || $[21] !== props.showBalance) {
    t10 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[19] = props.height;
    $[20] = props.nft;
    $[21] = props.showBalance;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== activeUrl || $[24] !== advanceToNextUrl || $[25] !== props.id || $[26] !== props.nft) {
    t11 = activeUrl ? <iframe title={props.id} src={activeUrl} id={props.id ?? `iframe-${props.nft.id}`} key={`${props.nft.contract}-${props.nft.id}-${activeUrl}`} onLoad={() => {
      setDidLoadCurrentUrl(true);
    }} onError={advanceToNextUrl} /> : null;
    $[23] = activeUrl;
    $[24] = advanceToNextUrl;
    $[25] = props.id;
    $[26] = props.nft;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t9) {
    t12 = <Col className={t9}>{t10}{t11}</Col>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t9;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
}